import React, { useState } from "react";
import BreadCrumb from "@/components/BreadCrumb";
import useFetchApi from "@/api/hooks/useFetchApi";
import Loader from "@/components/Loader/loader";

const Certificate: React.FC = () => {
    const [selectedImage, setSelectedImage] = useState<{ src: string; title: string } | null>(null);

    const handleOpenImage = (src: string, title: string) => {
        setSelectedImage({ src, title });
    };

    const handleCloseImage = () => {
        setSelectedImage(null);
    };

    const handleButtonClick = (item: any) => {
        if (item.url && item.url.trim() !== "") {
            window.open(item.url, "_blank");
        } else {
            handleOpenImage(
                item.resim || "https://gunes-gaz.b-cdn.net//no-image.svg",
                item.title || "Default Alt Text"
            );
        }
    };

    const { data, isLoading, error } = useFetchApi({
        url: "/v1/gp/677e18a2c44fb038b4a8551a/tr/find",
        service: "CMS_PROC"
    });

    return (
        <>
            <BreadCrumb title="Sertifikalar" parent="" child="Sertifikalar" />

            {(!isLoading && data) ? (
                <section className="ls ms section_padding_50">
                    <div className="container">
                        <div className="row">
                            {data?.results.map((item: any, index: number) => (
                                <div className="col-sm-4" key={"cert-" + index}>
                                    <div className="after_cover color_bg_1">
                                        <div className="teaser_content media">
                                            <div className="teaser text-center">
                                                <img
                                                    src={item.resim ? item.resim : "https://gunes-gaz.b-cdn.net//no-image.svg"}
                                                    style={{ objectFit: 'contain', width: "300px", height: "412px" }}
                                                    alt={item.title}
                                                />
                                                <h3>{item.title}</h3>
                                                <button
                                                    onClick={() => handleButtonClick(item)}
                                                    className="theme_button color2"
                                                >
                                                    İncele
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {selectedImage && (
                                <div
                                    style={{
                                        position: "fixed",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: "100%",
                                        backgroundColor: "rgba(0, 0, 0, 0.8)",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        zIndex: 1000,
                                    }}
                                    onClick={handleCloseImage}
                                >
                                    <img
                                        src={selectedImage.src}
                                        alt={selectedImage.title}
                                        style={{ maxWidth: "90%", maxHeight: "90%" }}
                                    />
                                </div>
                            )}
                        </div>
                    </div>
                </section>
            ) : (
                <Loader />
            )}
        </>
    );
};

export default Certificate;
